<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true //控制视图是否显示的变量
    };
  },
  mounted() {},
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true; //再打开
      });
    }
  }
};
</script>

<style lang="less">
.vxe-table--tooltip-wrapper {
  z-index: 9999 !important;
}
.size {
  width: 100%;
  height: 100%;
}
html,
body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
* {
  /*整体部分*/
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  /*滑动轨道*/
  &::-webkit-scrollbar-track {
    border-radius: 0px;
    background: none;
  }

  /*滑块*/
  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    background-color: rgba(255, 255, 255, 0.75);
  }

  /*滑块效果*/
  &::-webkit-scrollbar-thumb:hover {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    background-color: rgba(85, 85, 85, 0.4);
  }
}
.bg-page {
  background: #fff;
  height: 100%;
  border-radius: 6px;
  padding: 10px;
}
.ivu-btn,
.ivu-table,
.ivu-form .ivu-form-item-label,
.ivu-modal-body,
.ivu-input,
.ivu-select-dropdown-list .ivu-select-item,
.ivu-select-input,
.ivu-checkbox-wrapper,
.ivu-dropdown-item,
.ivu-tree ul {
  font-size: 14px !important;
}
.tree-box {
  .ivu-tree-title {
    font-size: 14px !important;
  }
}
.ivu-message {
  z-index: 9999 !important;
}
.ivu-layout-sider,
.ivu-menu-dark,
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
  background: #001529 !important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover,
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover {
  color: #fff !important;
  background: #001529 !important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
  background: #000c17 !important;
}
.ivu-input[disabled],
.ivu-select-input[disabled],
.ivu-input-number-disabled .ivu-input-number-input {
  -webkit-text-fill-color: #000 !important;
  color: #000 !important;
}
.cnb-div {
  width: 100%;
  height: 550px;
  overflow: auto;
}
.cnb-num {
  width: 110px;
  height: 40px;
  border: 1px solid #e8eaec;
  float: left;
  line-height: 40px;
  text-align: center;
}
.search-size {
  width: 160px !important;
}
.search-date {
  width: 140px !important;
}
.search-select {
  width: 180px !important;
}
.flex-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.price-content {
  // min-width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.span-head {
  font-size: 14px;
  font-weight: 600;
}
.span-unit {
  color: #000;
  font-size: 14px;
}
.span-title {
  color: red;
  font-size: 18px;
  font-weight: 600;
  margin-right: 10px;
  min-width: 100px;
}
.footer-div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 10px;
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.upload-flex {
  display: flex;
}
.html-div {
  height: 70vh;
  margin-bottom: 4px;
  overflow-y: auto;
  font-family: "仿宋";
  font-size: 20px;
}
.extand-li {
  margin-right: 20px;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
.bulletin-tit .ivu-modal-header-inner {
  text-align: center;
  height: 26px;
  line-height: 26px;
  font-size: 20px;
}
.indexCol {
  .ivu-col {
    margin-bottom: 10px !important;
  }
}
.loading-div {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  color: white;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.footer-content {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
}
.footer-content-item :first-child.span-head {
  padding-left: 10px;
  border-left: 1px solid rgb(204, 204, 204);
}
:first-child.footer-content-item :first-child.span-head {
  border-left: 0;
}
.vxe-body--expanded-cell {
  background: #f5f5f5;
  padding: 20px 0;
  padding-left: 35px !important;
}
.no-data {
  margin-top: 30px;
  text-align: center;
  font-size: 16px;
  color: #999;
}

.textCenter input {
  text-align: center;
}
</style>
